module.exports = __webpack_public_path__ + "media/images/growth-capital-ec2b92eb906a8d5eecd2a82497af27aa.svg";